import { useRouter } from "next/router";
import "../styles/globals.css";
import { useEffect } from "react";
import * as gtag from "utils/gtag";
import { appWithTranslation } from "next-i18next/pages";
import nextI18nConfig from "../next-i18next.config";
function MyApp({
  Component,
  pageProps
}: any) {
  const router = useRouter();
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    const handleRouteChange = (url: URL) => {
      gtag.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return <Component {...pageProps} />;
}
export default appWithTranslation(MyApp, nextI18nConfig);